<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let isOpen = false;
</script>

{#if isOpen}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div 
        style="z-index: 1000; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: white; opacity: 0.9"
        on:click={() => dispatch('close')}>
    </div>

    <div style="z-index: 1001; position: absolute; top: 0; left:0; width: 100%; height: 100%; pointer-events: none;  display: flex; justify-content: center; align-items: center;">
        <div style="background-color: white; width: 50%; margin: 0 auto; pointer-events: auto; border: 10px solid #9bd8fd; padding: 10px; margin: 5px; border-radius: 10px;">
            <slot></slot>
        </div>
    </div>
{/if}